import { gql } from 'graphql-tag';

const projectRatesFragment = gql`
  fragment ProjectRates on Project {
    projectRate: projectRate2 {
      id
      billingScheduleEntries {
        effectiveDate: effectiveDate2
        amount {
          currency {
            id
            symbol
            displayText
          }
          amount
        }
      }
    }
    roleRates: roleRates2 {
      id
      roleReference {
        id
        displayText
      }
      billingScheduleEntries {
        effectiveDate: effectiveDate2
        amount {
          currency {
            id
            symbol
            displayText
          }
          amount
        }
      }
    }
    userRates: userRates2 {
      id
      userReference {
        id
        displayText
      }
      billingScheduleEntries {
        effectiveDate: effectiveDate2
        amount {
          currency {
            id
            symbol
            displayText
          }
          amount
        }
      }
    }
  }
`;

export default projectRatesFragment;
